import React from 'react';
import myImage from './kachel_andere.jpg';

const kachelAndere = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelAndere;



